import React from "react";
import { useSelector } from "react-redux";
import { getAppUser } from "../../app/appSelectors";
import { Table } from "react-bootstrap";
import amountFormat from "../../utils/amountFormat";
import BalanceLogs from "../BalanceLogs/BalanceLogs";

export default function MainPage() {
    const userInfo = useSelector(getAppUser);

    return <>

        <h3>Profile</h3>
        <Table bordered variant="dark">
            <tbody>
            <tr>
                <td style={{ width: '200px' }}>Full Name</td>
                <td>{userInfo.username}</td>
            </tr>
            <tr>
                <td style={{ width: '200px' }}>Company Name</td>
                <td>{userInfo.company_name}</td>
            </tr>
            <tr>
                <td style={{ width: '200px' }}>Company Number</td>
                <td>{userInfo.company_number}</td>
            </tr>
            <tr>
                <td style={{ width: '200px' }}>Company Address</td>
                <td>{userInfo.address}</td>
            </tr>
            <tr>
                <td style={{ width: '200px' }}>Company License</td>
                <td>{userInfo.licence}</td>
            </tr>
            <tr>
                <td>Balance</td>
                <td>${amountFormat(userInfo.balance)}</td>
            </tr>
            </tbody>
        </Table>

        <BalanceLogs/>

    </>
}
